import { useEffect } from 'react';
import {
  getUserProjectsWithPagination,
  selectProjects,
  useAppDispatch,
  useAppSelector,
} from '@ideoz/core';

/**
 * Logic for the Design System module: resolves the startup's primary project
 * (the design system is stored per-project) and fetches it if not already in
 * the store.
 */
export function useDesignSystem(): { primaryProjectId: string | null } {
  const dispatch = useAppDispatch();
  const projects = useAppSelector(selectProjects);
  const primaryProjectId = (projects && projects[0]?.id) ?? null;

  useEffect(() => {
    if (!projects || projects.length === 0) {
      dispatch(getUserProjectsWithPagination({ limit: 1, page: 1 }));
    }
  }, [dispatch, projects]);

  return { primaryProjectId };
}
